import React from 'react'
import { ICard } from 'models'
import {
  animalColorTheme,
  HandAnimalColor,
  UIColorThemes,
  animalColorUiTheme,
} from 'global'
import { Box, IBoxProps, Card } from 'components'
import { MoodResultCard } from './MoodResultCard'
import { TouchResultCard } from './TouchResultCard'
import { SexResultCard } from './SexResultCard'
import { Tip } from './Tip'

interface IResultCardProps extends IBoxProps {
  card: ICard
  handColor: HandAnimalColor
  onLoaded: () => void
  onClick?: (event: React.MouseEvent) => void
}

interface IResultCardRenderer extends Omit<IResultCardProps, 'handColor'> {
  uiColorTheme: UIColorThemes
  hasTip: boolean
}

const ResultCardRenderer = ({
  card,
  uiColorTheme,
  onLoaded,
  hasTip,
}: IResultCardRenderer) => {
  const error = <p>Something went wrong...</p>
  switch (card.type) {
    case 'mood':
      return card.ways ? (
        <MoodResultCard
          uiColorTheme={uiColorTheme}
          ways={card.ways}
          onLoaded={onLoaded}
          hasTip={hasTip}
        />
      ) : (
        error
      )
    case 'sex':
      return card.ways ? (
        <SexResultCard
          uiColorTheme={uiColorTheme}
          ways={card.ways}
          onLoaded={onLoaded}
          hasTip={hasTip}
        />
      ) : (
        error
      )
    case 'touch':
      return card.speed && card.pressure && card.category ? (
        <TouchResultCard
          uiColorTheme={uiColorTheme}
          ways={card.ways}
          onLoaded={onLoaded}
          hasTip={hasTip}
          {...(card as Required<Omit<ICard, 'ways'>>)}
        />
      ) : (
        error
      )
    default:
      return error
  }
}

export const ResultCard = ({
  card,
  handColor,
  onLoaded,
  ...props
}: IResultCardProps) => {
  const uiTheme = animalColorUiTheme(handColor)

  return (
    <Card
      outerProps={props}
      innerProps={{
        backgroundColor: animalColorTheme(handColor),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <ResultCardRenderer
        onLoaded={onLoaded}
        card={card}
        hasTip={Boolean(card.tip)}
        uiColorTheme={uiTheme}
      />
      <Box>{card.tip && <Tip tip={card.tip} uiColorTheme={uiTheme} />}</Box>
    </Card>
  )
}
